/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__ClassInputs */

const en__field__class = /** @type {(inputs: _Field__ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Class (internal)`)
};

const de__field__class = /** @type {(inputs: _Field__ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse (intern)`)
};

/**
* | output |
* | --- |
* | "Class (internal)" |
*
* @param {_Field__ClassInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field__class = /** @type {((inputs?: _Field__ClassInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__ClassInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__class(inputs)
	return de__field__class(inputs)
});